import * as R from "ramda";

import {
  generateItemsReducer,
  generateStateActions,

  generateItemAndActionsFromStore,
  generateItemListAndActionsFromStore,
} from "./item";

const itemType = "activityUserState";
const endpoint = "activity_user_states/";

export const activityUserStatesReducer = generateItemsReducer<ActivityUserStateSnakeModel, {}>(itemType);

function activityUserStateMergeFunction(rawItem: ItemStateLoaded<ActivityUserStateSnakeModel, {}>): ActivityUserStateSnakeModel {
  return {
    ...rawItem.savedData,
    ...rawItem.editData,
    state: R.mergeDeepRight(rawItem.savedData.state, rawItem.editData?.state || {}),
  };
}

export const activityUserStateAndActionsFromStore = generateItemAndActionsFromStore<ActivityUserStateSnakeModel, {}, ItemStateActions>(
  itemType,
  endpoint,
  generateStateActions,
  activityUserStateMergeFunction,
);

export const activityUserStateListAndActionsFromStore = generateItemListAndActionsFromStore(itemType, activityUserStateAndActionsFromStore);
